import { Illustration } from 'modules/common/components/Illustrations/Illustration'
import { useTranslation } from 'modules/common/hooks/useTranslation'
import { SponsorshipStepper } from './SponsorshipStepper/SponsorshipStepper'

export const SponsorshipProcessContainer = () => {
  const { t } = useTranslation('settings-components')

  return (
    <div className="flex w-full flex-col items-center rounded-2xl border border-info-100 p-12">
      <Illustration name="sponsorship" size="m" className="mb-6" />
      <h2 className="pb-8">{t('sponsorshipProcessContainer.title')}</h2>
      <SponsorshipStepper />
    </div>
  )
}
